import AuthenticationService from './../../services/AuthenticationService'
import alerts from '@/alerts/alert'
import Store from '@/store'
import confirmations from './confirmations'
const branches = {
  namespaced: true,
  state: {
    datas: {},
    data: [],
    branches: [],
    loading: false,
    modal: false,
    label: 'Create',
    queryParam: null,
    form: {
      branch_name: 'TES',
      branch_code: 'TES',
      province_id: 36,
      city_id: 3671,
      district_id: 3671011,
      village_id: 3671011005,
      postal_code: '15155',
      address: 'Jl. Tes',
      phone_number: '08888888',
      email: 'tes@gmail.com',
      contact_person: 'tess',
      contact_number: '09999999',
      coordinate: '09090909090',
      is_head_office: 1,
      active: 1
    }
  },
  getters: {
    getBranches (state) {
      return state.branches
    }
  },
  mutations: {
    SET_DATAS (state, data) {
      state.datas = data
    },
    SET_DATA (state, data) {
      state.data = data
    },
    SET_BRANCHES (state, data) {
      state.branches = data
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_LABEL (state, data) {
      state.label = data
    },
    SET_FORM (state, data) {
      state.form = data
    },
    SET_QUERY_PARAM (state, data) {
      state.queryParam = data
    }
  },
  actions: {
    async reqDataBranches ({ commit }, payload) {
      commit('SET_LOADING', payload)
      return await AuthenticationService.get('branches').then(({ data }) => {
        commit('SET_BRANCHES', data.data)
        commit('SET_LOADING', false)
      })
    },
    async paginate ({ commit }, payload) {
      commit('SET_LOADING', payload.loading)
      commit('SET_QUERY_PARAM', payload.datas)
      return await AuthenticationService.get('branches/paginate?' + payload.datas).then(({ data }) => {
        commit('SET_DATAS', data.data)
        commit('SET_DATA', data.data.data)
        commit('SET_LOADING', false)
      })
    },
    getCity  ({ state }) {
      Store.dispatch('cities/all', state.form.province_id)
    },
    getDistrict  ({ state }) {
      Store.dispatch('districts/all', state.form.city_id)
    },
    getVillage  ({ state }) {
      Store.dispatch('villages/all', state.form.district_id)
    },
    confirmationSave () {
      confirmations.confirmationForm('branches/save')
    },
    async save ({ commit, state }) {
      Store.dispatch('loading/setLoading', true)
      try {
        if (state.label === 'Create') {
          return await AuthenticationService.post('branches/create', state.form).then(({ data }) => {
            state.branches.push(state.form)
            Store.dispatch('loading/setLoading', false)
            Store.dispatch('branches/reqDataBranches', false)
            if (data.code === 200) {
              state.modal = false
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'Update' || state.label === 'AutoUpdate') {
          return await AuthenticationService.post('branches/update/' + state.form.id, state.form).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            Store.dispatch('branches/reqDataBranches', false)
            if (data.code === 200) {
              state.modal = false
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'Delete') {
          return await AuthenticationService.delete('branches/delete/' + state.form.id).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            if (data.code === 200) {
              const index = state.branches.findIndex(item => item.id === state.form.id)
              state.branches.splice(index, 1)
              Store.dispatch('branches/reqDataBranches', false)
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        }
      } catch (error) {
        Store.dispatch('loading/setLoading', false)
        alerts.sweetalertToast('error', error.message)
      }
    },
    onAction ({ commit, state }, payload) {
      commit('SET_LABEL', payload[1])
      commit('SET_FORM', payload[0])
      if (payload[1] === 'Delete') {
        confirmations.confirmationDelete('branches/save')
      } else if (payload[1] === 'AutoUpdate') {
        state.form.is_active = 0
        confirmations.confirmationForm('branches/save')
      } else {
        state.modal = true
        if (payload[1] === 'Update' && state.form.province_id > 0) {
          Store.dispatch('branches/getCity')
          if (payload[1] === 'Update' && state.form.city_id > 0) {
            Store.dispatch('branches/getDistrict')
            if (payload[1] === 'Update' && state.form.district_id > 0) {
              Store.dispatch('branches/getVillage')
            }
          }
        }
      }
    },
    onInputImage ({ state }, payload) {
      state.form[payload[1]] = payload[0]
    },
    onRefresh ({ state }) {
      Store.dispatch('branches/reqDataBranches', true)
    }
  }
}

export default branches
